import { VariaveisAmbiente } from 'config';
import { PessoaInfoModel } from 'model/api/gestao/pessoa/pessoa-info-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePostAdicionarPessoaInfo() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postAdicionarPessoaInfo = useCallback(
        (pessoaId: string, info: PessoaInfoModel) =>
            invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/Pessoa/${pessoaId}/info`,
                data: info,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postAdicionarPessoaInfo,
    };
}
